import { render, staticRenderFns } from "./MarcadosSpam.vue?vue&type=template&id=544be660"
import script from "./MarcadosSpam.vue?vue&type=script&lang=js"
export * from "./MarcadosSpam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports